import { Fragment, useEffect, useState } from "react";
import { CollapseableCard } from "../../../CommonElements";
import { Col, Table } from "reactstrap";
import { useAbsensi } from "../../../Context/AbsensiContext";

const RekapAbsen = (props) => {
  const absensiAPI = useAbsensi();
  const stafId = localStorage.getItem("staf_id");
  const [absensi, setAbsensi] = useState([]);
  const [lokasiAbsen, setLokasiAbsen] = useState();
  const [loading, setLoading] = useState(true);

  const month = new Date().getMonth() + 1;
  const year = new Date().getFullYear();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const lokasi = await absensiAPI.getLokasi();
      setLokasiAbsen(lokasi.data);
      const detailRes = await absensiAPI.getDetailAbsensiByStafAndDate(
        stafId,
        `${year}-${month}`
      );
      const absenRes = await absensiAPI.getAbsensiByStafAndDate(
        stafId,
        `${year}-${month}`
      );
      getWeekDatesData(absenRes?.data, detailRes?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  function getWeekDatesData(data, details) {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const diffToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

    const monday = new Date(today);
    monday.setDate(today.getDate() - diffToMonday);

    const friday = new Date(monday);
    friday.setDate(monday.getDate() + 4);

    const filteredData = data.filter((item) => {
      const itemDate = new Date(item.tanggal);
      return itemDate >= monday || itemDate <= friday;
    });

    const detail = filteredData.map((item) => {
      const itemDetails = details?.filter(
        (detail) => detail.id_absensi === item.id_absensi
      );
      return {
        ...item,
        detail: itemDetails || [],
      };
    });

    setAbsensi(detail);
  }

  function getWeekDates() {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const diffToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    const monday = new Date(today);
    monday.setDate(today.getDate() - diffToMonday);
    const weekDates = [];
    for (let i = 0; i < 5; i++) {
      const date = new Date(monday);
      date.setDate(monday.getDate() + i);
      const options = {
        weekday: "long",
        day: "numeric",
        month: "short",
        year: "numeric",
      };
      weekDates.push(date.toLocaleDateString("id-ID", options));
    }
    return weekDates;
  }

  function getLocationName(id_lokasi) {
    const location = lokasiAbsen?.find((loc) => loc.id_lokasi === id_lokasi);
    return location ? location.nama_lokasi : null;
  }

  function renderTableRows() {
    const weekDates = getWeekDates();
    return weekDates.map((dateString) => {
      const absensiForDate = absensi.find(
        (item) =>
          new Date(item.tanggal).toLocaleDateString("id-ID", {
            weekday: "long",
            day: "numeric",
            month: "short",
            year: "numeric",
          }) === dateString
      );

      if (absensiForDate) {
        const jamMasuk =
          absensiForDate.detail?.find((d) => d.mode === 1)?.jam || "-";
        const lokasiMasuk =
          absensiForDate.detail?.find((d) => d.mode === 1)?.id_lokasi ||
          "Tidak Ada Lokasi";
        const jamPulang =
          absensiForDate.detail?.find((d) => d.mode === 2)?.jam || "-";
        const lokasiPulang =
          absensiForDate.detail?.find((d) => d.mode === 2)?.id_lokasi ||
          "Tidak Ada Lokasi";

        return (
          <tr key={dateString}>
            <td>{dateString}</td>
            <td className="text-center">
              {jamMasuk} ({getLocationName(lokasiMasuk)})
            </td>
            <td className="text-center">
              {jamPulang === "-"
                ? "-"
                : `${jamPulang} ${getLocationName(lokasiPulang)}`}
            </td>
            <td className="text-center">
              {absensiForDate.id_tipe_absensi || "-"}
            </td>
            <td className={absensiForDate.keterangan ? "" : "text-center"}>
              {absensiForDate.keterangan || "-"}
            </td>
          </tr>
        );
      }

      return (
        <tr key={dateString}>
          <td>{dateString}</td>
          <td className="text-center">-</td>
          <td className="text-center">-</td>
          <td className="text-center">-</td>
          <td className="text-center">-</td>
        </tr>
      );
    });
  }

  return (
    <Fragment>
      <Col {...props}>
        <CollapseableCard title={"Rekap Absen"}>
          <div>
            <Table>
              <tbody>
                <tr>
                  <th>Periode</th>
                  <td>
                    : {getWeekDates()[0]} s.d. {getWeekDates()[4]}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
          <div className="overflow-auto">
            <Table className="mt-4 table-bordered border-dark">
              <thead>
                <tr className="text-center">
                  <th>Tanggal</th>
                  <th>Jam Masuk</th>
                  <th>Jam Pulang</th>
                  <th>Tipe Absensi</th>
                  <th>Keterangan</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="5" className="text-center">
                      Loading...
                    </td>
                  </tr>
                ) : (
                  renderTableRows()
                )}
              </tbody>
            </Table>
          </div>
        </CollapseableCard>
      </Col>
    </Fragment>
  );
};

export default RekapAbsen;
